import './index.css';

const RequestItemContainer = ({ children }) => {
    return (
        <div className="request-item-container">
            {children}
        </div>
    )
}

export default RequestItemContainer;